import Navigation from './Navigation';
import logoAsset from '@/assets/terravia-logo.png.asset.json';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="pt-16 sm:pt-20">
        {children}
      </main>
      <footer className="bg-muted/30 border-t border-border mt-0">
        <div className="container mx-auto px-5 sm:px-6 lg:px-8 py-16 sm:py-20">
          <div className="text-center space-y-6">
            <div className="flex justify-center">
              <img src={logoAsset.url} alt="Terravia Ceramics" className="h-16 sm:h-20 w-auto object-contain" />
            </div>
            <p className="text-muted-foreground max-w-md mx-auto text-sm sm:text-base leading-relaxed">
              Contemporary pottery and ceramic art shaped by earth and fire.
            </p>
            <div className="text-sm text-muted-foreground">
              <span>© 2025 Terravia Ceramics</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
